export interface EmbedReport {
    // Id of Power BI report to be embedded
    reportId: string;

    // Name of the report
    reportName: string;

    // Embed URL for the Power BI report
    embedUrl: string;
}

export interface EmbedParams {
    type: string;
    embedReports: EmbedReport[];
    embedToken: any;
    navContentEnabled: boolean;
    filters: EmbedFilterModel[]
}

export interface EmbedFilterModel
{
    tableName: string;
    columnName: string;
    operator: string;
    value: string;
    filterType: number;
}

export enum EmbedFilterTypeEnum
{
    Slicer = 1,
    Filter = 2
}